import { createStyles, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { PublishStatus, QuestionStatus } from '../../../../graphql/gen/types';
import { colorPalette, spacings, TextSizesEnum } from '../../../../theme';
import { PlexTypography } from '../../../shared/primitives/PlexTypography';
import { PlexName } from '../../common/PlexName';
import { PostAuthor } from '../../common/PostAuthor';
import { PostDate } from '../../common/PostDate';
import { PostVisibility } from '../../common/PostVisibility';

type Props = {
  className?: string;
  plexName: string;
  plexColor: string | null | undefined;
  plexPublishStatus: PublishStatus | QuestionStatus;
  authorAvatar?: string;
  authorName: string;
  authorTitle: string | null | undefined;
  publishedDate: number | string;
  showUnreadBadge: boolean;
};

export function PlexHeader(props: Props): React.ReactElement {
  const {
    plexName,
    plexColor,
    plexPublishStatus,
    authorAvatar,
    authorName,
    authorTitle,
    publishedDate,
    className,
    showUnreadBadge,
  } = props;
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.headerLeft}>
        {showUnreadBadge && (
          <PlexTypography className={classes.unreadBadge} text={'New!'} size={TextSizesEnum.Normal} />
        )}
        <PlexName name={plexName} color={plexColor} />
        <PostAuthor
          classes={{ root: classes.author }}
          authorName={authorName}
          authorAvatar={authorAvatar}
          authorTitle={authorTitle}
        />
      </div>
      <div className={classes.headerRight}>
        <PostDate date={new Date(publishedDate)} />
        <div className={classes.publishStatus}>
          <PostVisibility plexPublishStatus={plexPublishStatus} plexName={plexName} />
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: spacings.xlarge,
      paddingTop: spacings.normal,
      paddingBottom: spacings.normal,
    },
    author: {
      marginLeft: spacings.xxlarge,
    },
    headerLeft: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerRight: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    publishStatus: {
      display: 'flex',
      color: colorPalette.purpleGray._500,
      fontSize: theme.typography.fontSize,
      marginLeft: spacings.small,
    },
    unreadBadge: {
      color: colorPalette.red._400,
      fontWeight: 'bold',
      marginRight: spacings.small,
    },
  })
);
